module.exports = __webpack_public_path__ + "assets/b363122c6b4ee52021b4bdda16f2fa3b.svg";